import { createTheme } from '@mui/material/styles';
const CironDisplayBlack = require('./css/Fonts/Ciron-Display/RGCironDisplay-Black.ttf');
const CironDisplayHeavyItalic = require('./css/Fonts/Ciron-Display/RGCironDisplay-HeavyItalic.ttf');
const CironDisplayMedium = require('./css/Fonts/Ciron-Display/RGCironDisplay-Medium.ttf');
const CironDisplayClasic = require('./css/Fonts/Ciron-Display/RGCironDisplay-Regular.ttf');
const CironDisplayLight = require('./css/Fonts/Ciron-Display/RGCironDisplay-Light.ttf');
const AmericanMono = require('./css/Fonts/America-Mono/GT-America-Mono-Medium.otf');
//const AmericanMonoBold = require('./css/Fonts/America-Mono/GT-America-Mono-Bold.otf');

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    login: true;
    outlinedWhite: true;
    outlinedDangerous: true;
    containedPill: true;
    containedPillSelected: true;
  }
}

export const Theme = createTheme({
  palette: {
    primary: {
      main: '#B59E5F',
      dark: '#B59E5F',
      light: 'rgba(0, 174, 239, 0.2)',
      contrastText: '#2D2926',
    },
    secondary: {
      main: '#F1F1F1',
      dark: '#DBD8DF',
      light: 'rgba(19, 103, 11, 0.04)',
      contrastText: '#2D2926',
    },
    error: {
      main: '#FF4141',
      dark: '#DB0000',
      contrastText: '#F1F1F1',
    },
  },
  typography: {
    fontFamily: [
      'Ciron Display',
      'Ciron Display Black',
      'Ciron Display Heavy Italic',
      'Ciron Display Classic',
      'American Mono',
    ].join(','),
    h1: {
      fontFamily: 'Ciron Display Heavy Italic',
      fontSize: 42,
      fontStyle: 'normal',
      fontWeight: 850,
      lineHeight: '90%' /* 50.4px */,
      letterSpacing: '-1px',
      color: '#FFFFFF',
    },
    h2: {
      fontFamily: 'Ciron Display',
      fontSize: 24,
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '120%' /* 28.8px */,
      color: '#F1F1F1',
      textTransform: 'capitalize',
    },
    h3: {
      fontFamily: 'Ciron Display',
      fontSize: 18,
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '120%' /** 21.6px */,
      color: '#FFFFFF',
      textTransform: 'capitalize',
    },
    h4: {
      fontFamily: 'Ciron Display Black',
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 900,
      lineHeight: '120%' /** 16.8px */,
      letterSpacing: '0.7px',
      color: '#FFFFFF',
      textTransform: 'uppercase',
    },
    h5: {
      fontFamily: 'Ciron Display',
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '120%' /** 16.8px */,
      color: '#F1F1F1',
      textTransform: 'capitalize',
    },
    h6: {
      fontFamily: 'Ciron Display Classic',
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 300,
      lineHeight: '120%' /** 16.8px */,
      color: '#FFFFFF',
    },
    subtitle1: {
      fontFamily: 'Ciron Display Classic',
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '120%' /** 16.8px */,
      color: '#D9D9D9',
    },
    subtitle2: {
      fontFamily: 'Ciron Display',
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 900,
      lineHeight: '120%' /** 16.8px */,
      color: '#FFFFFF',
      textTransform: 'capitalize',
    },
    body1: {
      fontFamily: 'Ciron Display Classic',
      fontSize: 16,
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '140%' /** 22.4px */,
      color: '#F1F1F1',
    },
    body2: {
      fontFamily: 'Ciron Display',
      fontSize: 18,
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '120%' /** 21.6px */,
      color: '#FFFFFF',
    },
    button: {
      fontFamily: 'American Mono',
      fontSize: 16,
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '120%' /** 19.2px */,
      color: '#F1F1F1',
    },
    caption: {
      fontFamily: 'Ciron Display Classic',
      fontSize: 12,
      fontStyle: 'normal',
      fontWeight: 300,
      lineHeight: '120%' /** 14.4px */,
      color: '#FFFFFF',
    },
    overline: {},
  },
  components: {
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          marginRight: 2,
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: `
      &::-webkit-scrollbar {
        width: 0px;
        height: 5px;
      }

      &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.2) ;
      }
      
      &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.4) ;
        border-radius: 2px;
      }
        body {
          margin: 0;
          padding: 0;
          width: 100%;
          height: 100%;
          background-color: #2D2926 !important;
        }

        @font-face{
          font-family:"Ciron Display";
          src:url(${CironDisplayMedium}) format("truetype");
        }

        @font-face{
          font-family:"Ciron Display Classic";
          src:url(${CironDisplayClasic}) format("truetype");
        }
        
       @font-face{
          font-family:"Ciron Display Black";
          src:url(${CironDisplayBlack}) format("truetype");
        }
        
      @font-face{
        font-family:"Ciron Display Heavy Italic";
        src:url(${CironDisplayHeavyItalic}) format("truetype");
      }

      @font-face{
        font-family:"Ciron Display Light";
        src:url(${CironDisplayLight}) format("truetype");
      }

      @font-face{
        font-family:"American Mono";
        src:url(${AmericanMono}) format("opentype");
      }        
    `
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          height: 40,
          padding: '8px 16px',
          border: '1px solid rgba(255, 255, 255, 0.4)',
          borderRadius: '4px',
          outline: 'none',
          color: '#F1F1F1',
          '&:focus-within': {
            border: '1px solid white',
          },
          input: {
            marginRight: '15px',
            padding: '8px 16px',
            fontFamily: 'Ciron Display Classic',
            fontSize: 16,
            //height: 40,
            fontStyle: 'normal',
            fontWeight: 300,
            lineHeight: '140%' /** 22.4px */,
            '&:-webkit-autofill': {
              margin: '4px',
              padding: '4px 12px',
              fontFamily: 'Ciron Display Classic',
              fontSize: 16,
              fontStyle: 'normal',
              fontWeight: 300,
              lineHeight: '140%' /** 22.4px */,
              //WebkitBoxShadow: '0 0 0 100px rgb(0, 0, 0, 0.80) inset',
              WebkitBoxShadow: '0 0 0 100px rgba(45, 41, 38, 0.94) inset',
              WebkitTextFillColor: '#F1F1F1',
            },
          },
        },
      },
    },
    MuiDrawer: {
      defaultProps: {
        PaperProps: {
          style: {
            padding: 32,
            minWidth: 400,
            width: 400,
            height: '100%',
            backgroundColor: '#2d2926ff',
            boxShadow:
              '0px 8px 10px -5px rgba(255,255,255,0.2),0px 16px 24px 2px rgba(255,255,255,0.14),0px 6px 30px 5px rgba(255,255,255,0.12)',
          },
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        style: {
          // backgroundColor: 'transparent',
          //padding: '6px 3px 6px 16px',
        },
      },
    },
    /*
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#2D2926',
        },
      },
    },*/
    MuiButton: {
      variants: [
        {
          props: { variant: 'outlined' },
          style: {
            borderRadius: 8,
            fontSize: 16,
            textTransform: 'capitalize',
            padding: '10px 16px 10px 16px',
            '& svg': {
             // marginTop: '-6px',
            },
            '&:disabled': {
              color: '#001A24',
              border: '1.5px solid #001A24',
            },
          },
        },
        {
          props: { variant: 'outlinedWhite' },
          style: {
            borderRadius: 8,
            fontSize: 16,
            textTransform: 'capitalize',
            padding: '10px 16px',
            border: '1.5px solid #DBD8DF',
            color: '#F1F1F1',
            background: "#2D2926",
            '& svg': {
              fill: '#F1F1F1',
              //marginTop: '-6px',
            },
            '&:hover': {
              background: 'rgba(255, 255, 255, 0.2)',
            },
            '&:disabled': {
              color: '#001A24',
              border: '1.5px solid #001A24',
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
            },
          },
        },
        {
          props: { variant: 'outlinedDangerous' },
          style: {
            borderRadius: 8,
            fontSize: 16,
            textTransform: 'capitalize',
            padding: '10px 16px',
            border: '1.5px solid #FF4141',
            color: '#FF4141',
            '& svg': {
              fill: '#DB0000',
              //marginTop: '-6px',
            },
            '&:hover': {
              background: 'rgba(255, 65, 65, 0.2)',
              border: '1.5px solid #DB0000',
              color: '#DB0000',
              '& svg': {
                fill: '#DB0000',
              },
            },
            '&:disabled': {
              color: '#001A24',
              border: '1.5px solid #001A24',
            },
          },
        },
        {
          props: { variant: 'containedPill' },
          style: {
            borderRadius: 0,
            fontSize: 16,
            textTransform: 'capitalize',
            padding: '10px 16px',
            color: '#2D2926',
            background: '#D9D9D9',
            '& svg': {
              fill: '#2D2926',
              //marginTop: '-6px',
            },
            '&:hover': {
              background: '#F1F1F1',
              color: '#2D2926',
              '& svg': {
                fill: '#2D2926',
              },
            },
            '&:disabled': {
              color: '#B3B3B3',
              background: '#001A24',
              '& svg': {
                fill: '#B3B3B3',
              },
            },
            '&.Mui-selected': {
              color: '#000',
              background: '#B59E5F',
              '& svg': {
                fill: '#000',
              },
            },
            '&:selected': {
              color: '#000',
              background: '#B59E5F',
              '& svg': {
                fill: '#000',
              },
            },
          },
        },
        {
          props: { variant: 'containedPillSelected' },
          style: {
            borderRadius: 0,
            fontSize: 16,
            textTransform: 'capitalize',
            padding: '10px 16px',
            color: '#000',
            background: '#B59E5F',
            '& svg': {
              fill: '#000',
              //marginTop: '-6px',
            },
            '&:hover': {
              background: '#F1F1F1',
              color: '#2D2926',
              '& svg': {
                fill: '#2D2926',
              },
            },
            '&:disabled': {
              color: '#B3B3B3',
              background: '#001A24',
              '& svg': {
                fill: '#B3B3B3',
              },
            },
          },
        },
        {
          props: { variant: 'contained' },
          style: {
            borderRadius: 8,
            fontSize: 16,
            textTransform: 'capitalize',
            padding: '10px 16px',
            '& svg': {
              //marginTop: '-6px',
            },
            '&:disabled': {
              background: '#001A24',
              color: '#B3B3B3',
            },
          },
        },
        {
          props: { variant: 'login' },
          style: {
            background: '#DBD8DF',
            borderRadius: 8,
            boxShadow: 'none',
            fontSize: 16,
            lineHeight: '120%',
            textTransform: 'capitalize',
            color: '#000',
            padding: '10px 16px',
            '& svg': {
              //marginTop: '-6px',
            },
            '&:hover': {
              background: '#FFFFFF',
              color: '#000',
            },
          },
        },
        {
          props: { variant: 'text' },
          style: {
            textTransform: 'capitalize',
            fontSize: 14,
            fontWeight: 500,
            lineHeight: '120%',
            borderRadius: '2px',
            color: '#FFFFFF',
            height: 32,
            alignItems: 'flex-end',
            '& svg': {
              //marginTop: '-6px',
            },
            '&:hover': {
              background: '#DEE2E6',
              color: '#011E41',
              borderRadius: '4px',
              '& svg': {
                transition: 'all 0.3s',
                fill: '#000000',
              },
            },
          },
        },
      ],
    },
    MuiTab: {
      defaultProps: {
        style: {
          color: '#FFF',
          textTransform: 'capitalize',
          fontFamily: 'Ciron Display',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '120%' /* 16.8px */,
        },
      },
    },
    MuiTabs: {
      defaultProps: {
        indicatorColor: 'secondary',
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          backgroundColor: '#2D2926',
        },
      },
    },
    MuiListItemButton: {
      defaultProps: {
        disableTouchRipple: true,
        style: {
          padding: '20px 16px',
        },
      },
      styleOverrides: {
        root: {
          borderBottom: '1px solid rgba(255, 255, 255, 0.40)',
          borderLeft: '4px solid transparent',
          '&:hover': {
            background: ' rgba(255, 255, 255, 0.20)',
            borderRadius: '4px',
          },
          '&.Mui-selected': {
            background: ' rgba(255, 255, 255, 0.20)',
            borderLeft: '4px solid #B59E5F',
          },
        },
      },
    },
    MuiListItemIcon: {
      defaultProps: {
        style: {
          //color: 'yellow',
          //backgroundColor: 'blue',
          minWidth: 0,
          marginRight: 16,
        },
      },
      styleOverrides: {
        root: {
          '&:hover': {
            //background: '#DEE2E6',
            //color: '#011E41',
            borderRadius: '4px',
          },
        },
      },
    },
    MuiSvgIcon: {
      defaultProps: {
        style: {
          //fontSize: 20,
          color: '#F1F1F1',
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontFamily: 'American Mono',
          fontWeight: 500,
          lineHeight: '120%' /** 19.2px */,
        },
      },
    },
    /*
    MuiStepper: {
      styleOverrides: {
        root: {
          '&:nth-child()': {},
        },
      },
    },*/
    MuiPagination: {},
    MuiPaginationItem: {
      defaultProps: {
        style: {
          color: '#F1F1F1',
        },
      },
      styleOverrides: {
        root: {
          /*
          '& svg': {
            fill: '#FFFFFF',
            cursor: 'pointer',
          },*/
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
          },
          '&.Mui-selected': {
            backgroundColor: 'rgba(0, 174, 239, 0.2)',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
            },
          },
        },
      },
    },
  },
});
